// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AudioRecordingController from "./audio_recording_controller"
application.register("audio-recording", AudioRecordingController)

import AutoRecordSettingController from "./auto_record_setting_controller"
application.register("auto-record-setting", AutoRecordSettingController)

import CardDisplayController from "./card_display_controller"
application.register("card-display", CardDisplayController)

import ClipboardCopyController from "./clipboard_copy_controller"
application.register("clipboard-copy", ClipboardCopyController)

import DevLoginController from "./dev_login_controller"
application.register("dev-login", DevLoginController)

import ExaminationAutoSaveController from "./examination_auto_save_controller"
application.register("examination-auto-save", ExaminationAutoSaveController)

import ExaminationTransferredController from "./examination_transferred_controller"
application.register("examination-transferred", ExaminationTransferredController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import MicrophoneSelectorController from "./microphone_selector_controller"
application.register("microphone-selector", MicrophoneSelectorController)

import MemoToggleController from "./memo_toggle_controller"
application.register("memo-toggle", MemoToggleController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import RecordingHeaderController from "./recording_header_controller"
application.register("recording-header", RecordingHeaderController)

import SoapPromptSelectorController from "./soap_prompt_selector_controller"
application.register("soap-prompt-selector", SoapPromptSelectorController)

import SoapSectionCopyController from "./soap_section_copy_controller"
application.register("soap-section-copy", SoapSectionCopyController)

import SoapQrController from "./soap_qr_controller"
application.register("soap-qr", SoapQrController)

import SonioxRecordingController from "./soniox_recording_controller"
application.register("soniox-recording", SonioxRecordingController)

import SonioxStatusController from "./soniox_status_controller"
application.register("soniox-status", SonioxStatusController)

import StripeCardController from "./stripe_card_controller"
application.register("stripe-card", StripeCardController)

import TranscriptSelectorController from "./transcript_selector_controller"
application.register("transcript-selector", TranscriptSelectorController)
